<!--
Events screen
@author ab557z
-->

<template>
  <div id="contain" class="container">
    <Nav name="Event" :step="true" />
    <Spinner ref="spinner" />
    <main class="p-2">
      <ExpandedEvent v-if="dispEvent"
                  :key="dispEvent.id" :title="dispEvent.title" :id="dispEvent.id"
                  :startDate="dispEvent.startDate"
                  :endDate="dispEvent.endDate"
                  :email="dispEvent.contactEmail"
                  :startTime="dispEvent.startTime"
                  :endTime="dispEvent.endTime"
                  :loc="dispEvent.location"
                  :basis="dispEvent.entryBasis"
                  :capacity="dispEvent.capacity"
                  :description="dispEvent.description"
                  :categories="dispEvent.categories"
        />
    </main>
    <div id="pusher"></div>
    <Footer active="events"/>
  </div>
</template>

<script setup>
//Utilities
import {ref, onMounted} from 'vue'
import * as lst from '@/components/localStorage.js'
import { store } from '@/components/reactiveStore.js'

//Components
import ExpandedEvent from '@/components/events/ExpandedEvent.vue'
import Footer from '@/components/FooterMenu.vue'

const props = defineProps({
  event: Object
})

//Data
const lsLastEvent = lst.getValue('lastEvent')
if (typeof lsLastEvent == 'undefined') {
  console.log('no last event')
}
let disp = typeof props.event !== 'undefined' ? props.event : JSON.parse(lsLastEvent)

const dispEvent = ref(disp)
const dispClub = ref(null)

onMounted(() => {
  // TODO if mounted panic and go get a cookie
  // no do not use cookies. iOS doesn't like
  const eventStore = store.get()
  if (eventStore) {
    dispEvent.value = eventStore.event
  } else {
    console.error('sorry no event info from previous page')
  }
  if (dispEvent.value) {
    lst.setValue('lastEvent', JSON.stringify(dispEvent.value))
  } else { 
    dispClub.value = lst.getValue('lastEvent') 
  }
  window.scrollTo(0, 0)
})

</script>

<style scoped>
.covidHeaderContainer {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
